import React from "react";
import { Box } from "@material-ui/core";

import { DescriptionText } from "../DescriptionText";

import "./TotalSection.css";
import { TotalText } from "../TotalText";

export type DiscountItem = {
  title: string;
  price: number;
  quantity: number;
};

export type TotalSectionProps = {
  total: number;
  units: number;
  discounts?: DiscountItem[];
};

export const renderTotalSection = ({ total, units, discounts }: TotalSectionProps) => {
  const hasDiscounts = discounts && discounts.length > 0;
  return (
    <>
      {hasDiscounts &&
        discounts.map((discount, index) => (
          <div key={index} className="discountSectionContainer">
            <TotalText>{discount.title}</TotalText>
            <Box className="discountSectionDetails">
              <TotalText style={{ whiteSpace: "nowrap" }}>
                $ {discount.price === undefined || isNaN(discount.price) ? "-" : discount.price.toLocaleString("en-US")}
              </TotalText>
            </Box>
          </div>
        ))}
      <div className="totalSectionContainer">
        <TotalText>Total</TotalText>
        <Box className="totalSectionDetails" data-cypress-id={"totalSectionDetails"}>
          <TotalText>$ {isNaN(total) ? "-" : total.toLocaleString("en-US")}</TotalText>
          {units && Number(units) > 1 ? (
            <DescriptionText data-cypress-id={"totalSectionDetailsUnits"}>
              {isNaN(units) ? "-" : `${units.toLocaleString("en-US")} ${Number(units) > 1 ? "units" : "unit"}`}
            </DescriptionText>
          ) : null}
        </Box>
      </div>
    </>
  );
};

export const TotalSection = (props: TotalSectionProps) => {
  return renderTotalSection(props);
};
